// **** ---> Previous url : https://webnavigation.azure-api.net
//**** ----> New url : https://navigation-api.poilabs.com

console.log("ENVIRONMENT", process.env.VUE_APP_ENVIRONMENT);

export const baseUrl =
  process.env.VUE_APP_ENVIRONMENT === "production"
    ? "https://navigation-api.poilabs.com"
    : "https://navigationgatewaydev.purplepond-afb39346.northeurope.azurecontainerapps.io";
